
import { Card, Form, Col, Button } from '@deere/ux.uxframe-react'
import React, {useState} from 'react';
import { getFilledCMRTTemplate } from '../../services/download.service';
import { useOktaAuth } from '@okta/okta-react';
import { useTranslation } from "react-i18next";


export default function DownloadCMRTCard({ assignmentId, surveyId, loading, setLoading, isAuthMethodOkta, token }) {

    const [allParts, setAllParts] = useState(false);
    const { authState } = useOktaAuth();
    const { t } = useTranslation();

    const onChangeTemplate = (event) => {
        setAllParts(event.target.value === '1'?true:false) ;
    }

    const download = (event) => {
        try {
            setLoading(true)
            getFilledCMRTTemplate(assignmentId, surveyId, allParts, token, isAuthMethodOkta).then(r =>{
                setLoading(false);
            }).catch(err => {
                console.log(err);
                setLoading(false);
            });
        }
        catch (err) {
            setLoading(false);
            throw err
        }
    }

    return (<div>
            <Card>
                <Card.Body>
                    <Card.Title className='pb-3 font-weight-bold'>
                        2. {t('cm_lbl_download_card_header')}
                    </Card.Title>
                    <Form.Row className="d-block mb-4">
                        <Form.Group>
                            <Form.Label className="">{t('cm_lbl_download_choose')}</Form.Label>
                            <br/>
                            <Form.Label className="uxf-label">{t('cm_lbl_download_new')}</Form.Label>
                            <Form.Check
                                required={true}
                                type="radio" value='0' id='0' label={t('cm_lbl_download_not_declared')}
                                name='allParts' onChange={(e) => onChangeTemplate(e)}/>
                            <Form.Check
                                required={true}
                                type="radio" value='1' id='1' label={t('cm_lbl_download_all_parts')}
                                name='allParts' onChange={(e) => onChangeTemplate(e)}/>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Col>
                            <Button variant="primary" className="float-right" onClick={download} disabled={loading}>
                                {t('btn_download')}
                            </Button>
                        </Col>
                    </Form.Row>
                </Card.Body>
            </Card>
        </div>);
}